import { FC } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setOffline } from '../../../modules/application/offline';
import { loginOfflineUser } from '../../../modules/user';

const Container = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    position: absolute;
    left: 50%;
    bottom: 30%;
    transform: translateX(-50%);
    background-color: ${color.grayscale[1000]};
    border: 1px solid ${color.grayscale.black};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 2.4375rem 1.25rem 3rem;
  `;
});

const IconContainer = styled.div`
  position: relative;
  width: 5.9375rem;
  height: 5.9375rem;
`;

const TextContainer = styled.div(({ theme }) => {
  const { color, type } = theme;
  return `
    color: ${color.grayscale.black};
    font-size: ${type.size.larger};
    padding: 1rem 2rem;
    white-space: nowrap;
  `;
});

const PlayOfflineButton = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[1000]};
    font-size: ${type.size.larger};
    background-color: ${color.grayscale.black};
    padding: 1rem 3rem;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      opacity: 0.8;
    }
  `;
});

const OfflineBanner: FC<{ offlineToken: string }> = ({ offlineToken }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = () => {
    dispatch(setOffline(true));
    dispatch(loginOfflineUser(offlineToken));
    history.push('/play');
  };

  return (
    <Container>
      <IconContainer aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.5 99.5">
          <defs>
            <clipPath id="a">
              <path data-name="Rectangle 4" d="M0 0h99.5v99.5H0z" fill="none" />
            </clipPath>
          </defs>
          <g data-name="Group 2">
            <g data-name="Group 1" clip-path="url(#a)">
              <path data-name="Path 1" d="M99.5 49.7A49.7 49.7 0 1 1 49.7 0a49.7 49.7 0 0 1 49.8 49.7" fill="#f5f5f5" />
              <path data-name="Path 2" d="M52 71.7a4.1 4.1 0 1 1-4.1-4.2 4.1 4.1 0 0 1 4 4.2" fill="#455a64" />
              <path
                data-name="Path 3"
                d="M39.6 66.4a11.4 11.4 0 0 1 16.5-.2c2.1 2 5.4-1.2 3.3-3.3a16 16 0 0 0-23 .2c-2 2.1 1.2 5.4 3.2 3.3"
                fill="#455a64"
              />
              <path
                data-name="Path 4"
                d="M25.7 47.2a33.7 33.7 0 0 1 22-8.8A32.7 32.7 0 0 1 70.4 47c2.1 2 5.4-1.2 3.2-3.2a37.5 37.5 0 0 0-25.7-10c-9.6 0-18.2 4-25.4 10.2-2.2 2 1 5.2 3.3 3.2"
                fill="#455a64"
              />
              <path
                data-name="Path 5"
                d="M31.2 57.8a22.6 22.6 0 0 1 33.2-.4c2.1 2.1 5.4-1.1 3.3-3.3a27.2 27.2 0 0 0-39.8.5c-2 2.1 1.3 5.4 3.3 3.2"
                fill="#455a64"
              />
              <path
                data-name="Path 6"
                d="M86.9 36.4a12.6 12.6 0 1 1-12.6-12.7 12.6 12.6 0 0 1 12.6 12.7"
                fill="#ff725e"
              />
              <path data-name="Rectangle 2" d="m69.7 39 8-8 1.8 1.8-8 8z" fill="#fff" />
              <path data-name="Rectangle 3" d="m69.7 32.8 1.8-1.8 8 8-1.8 1.8z" fill="#fff" />
            </g>
          </g>
        </svg>
      </IconContainer>
      <TextContainer>You're currently offline, but you can still play!</TextContainer>
      <PlayOfflineButton type="button" onClick={handleClick}>
        Play Restore Games
      </PlayOfflineButton>
    </Container>
  );
};

export default OfflineBanner;
